import request from '@/utils/request';

export function listSign(query?) {
  return request({
    url: '/system/signature/list',
    method: 'get',
    params: query
  });
}

export function addSign(data) {
  return request({
    url: '/system/signature/add',
    method: 'post',
    data: data
  });
}

export function getSign(id) {
  return request({
    url: '/system/signature/get/' + id,
    method: 'get'
  });
}

export function updateSign(data) {
  return request({
    url: '/system/signature/edit/',
    method: 'put',
    data: data
  });
}

export function delSign(ids) {
  return request({
    url: '/system/signature/remove/' + ids,
    method: 'delete'
  });
}

export function changeUserStatus(id, status) {
  const data = {
    id,
    status
  };
  return request({
    url: '/system/signature/changeStatus',
    method: 'put',
    data: data
  });
}
